import React from 'react';
import dayjs, { Dayjs } from 'dayjs';
import { Typography, TimePicker } from 'antd';

const { Text } = Typography;

interface TimeFieldProps {
  field: any;
  value: string | undefined;
  onChange: (value: string | undefined) => void;
  commonStyle: React.CSSProperties;
  labelStyle: React.CSSProperties;
  error?: string;
}

export const TimeField: React.FC<TimeFieldProps> = ({ field, value, onChange, commonStyle, labelStyle, error }) => {
  const format = 'HH:mm';
  const parsed: Dayjs | null = value ? dayjs(value, format) : null;

  return (
    <div style={commonStyle}>
      <Text type='secondary' style={{ ...labelStyle, textTransform: 'uppercase' }}>
        {field.label}
      </Text>
      <TimePicker
        value={parsed}
        format={format}
        minuteStep={5}
        showNow={false}
        onChange={t => onChange(t ? t.format(format) : undefined)}
        style={{ width: '100%' }}
        placeholder={field.placeholder ?? 'HH:mm'}
        status={error ? 'error' : undefined}
      />
      {error && (
        <Text type='danger' style={{ fontSize: 12, marginTop: 4 }}>
          {error}
        </Text>
      )}
    </div>
  );
};
